import React, { useState, useRef } from "react";
import styles from "./Otp.module.css";
import { prpHttpAPI } from "../../services/prpHttpAPI";
import { useNavigate } from "react-router-dom";

const Otp = ({ setShowModal, flag, name, number, tokan, nextH }) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [validOTP, setValidOTP] = useState(false);
  const inputRefs = useRef([]);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return; // Allow only digits (0-9) and max 1 character per box

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus(); // Move to next box
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus(); // Move back on backspace
    }
  };

  const submitOTP = async () => {
    const otpCode = otp.join(""); // Combine OTP array into a string
    console.log("OTP entered:", otpCode, number);

    let userObj = {
      phone_number: number,
      otp_code: otpCode,
    };

    const result = await prpHttpAPI(userObj, "opt/verify", tokan, "POST");

    console.log("OTP verify result", result);
    if (result.success) {
      setShowModal(false);
      nextH();
    } else {
      setShowModal(true);
      setValidOTP(true);
    }
  };

  return (
    <div className={styles.main}>
      <div className={styles.mainModal}>
        <p className={styles.cross} onClick={() => setShowModal(false)}>X</p>
        <div className={styles.heading}>Verify OTP</div>
        <div className={styles.subHeading}>One Time Password (OTP)</div>

        <div className="d-flex justify-content-center gap-2">
          {otp.map((value, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              value={value}
              maxLength="1"
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className={`form-control text-center ${styles['otp-textbox']}`}
            />
          ))}
        </div>

        {validOTP && <p className="text-danger p-2">Please enter a valid OTP</p>}

        <div>
          <button onClick={submitOTP} className={styles.planBtn}>
            SUBMIT
          </button>
        </div>
      </div>
    </div>
  );
};

export default Otp;
